import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'telefoneFormater',
    standalone: false
  })
  export class TelefoneFormaterPipe implements PipeTransform {
  
    transform(value: string | number): string {
      if (!value) return '';
  
      const phone = value.toString().replace(/\D/g, '');
  
      if (phone.length === 10) {
        // Formato (00) 0000-0000
        return `(${phone.substring(0, 2)}) ${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
      } else if (phone.length === 11) {
        // Formato (00) 00000-0000
        return `(${phone.substring(0, 2)}) ${phone.substring(2, 7)}-${phone.substring(7, 11)}`;
      }
  
      return value.toString();
    }
  }